<template>
    <sa-page-layout ref="SaplNotificationpayView" :btnCloseVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body"
            ><!-- 
            <rsa-configurazione-attivita-view-component :showModalLoading="showModalLoading" @errorRestCall="onError" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-configurazione-attivita-view-component> -->
            <notification-notipay-view-component ref="cmpNoitificationNotipayView"></notification-notipay-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import NotificationNotipayViewComponent from "../components/NotificationNotipayViewComponent.vue";
export default {
    components: { SaPageLayout, NotificationNotipayViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/notificationnotipay",
            linkback: "/notificationnotipay",
            jsonData: {},
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpNoitificationNotipayView.init(me.id);
        },
    },
};
</script>

<style></style>
